import {
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
} from '@mui/material/colors';

export const MUI_COLORS = [
  blue[500],
  green[500],
  purple[500],
  deepPurple[500],
  indigo[500],
  lightBlue[500],
  cyan[500],
  teal[500],
  lightGreen[500],
  lime[700],
  yellow[700],
  amber[700],
  orange[500],
  deepOrange[500],
];

export const hashColorKey = (
  colorKey: Record<string, string | number>,
): string => {
  const str = Object.keys(colorKey)
    .sort()
    .map((k) => `${k}:${colorKey[k]}`)
    .join(',');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % 2147483647;
  }
  return MUI_COLORS[hash % MUI_COLORS.length];
};
